import { DEFAULT_COLOR_GRAY, DEFAULT_MARKDOWN_TEXT } from '../constants'
import { baseSchemaProperties } from '../base-schema-properties'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Text Columns',
  description: 'Two text columns',
  type: 'object',
  required: ['text'],
  properties: {
    ...baseSchemaProperties,
    columns: {
      type: 'array',
      title: 'Text columns',
      'ui:options': {
        showIndexNumber: false,
        addable: false,
        sortable: false,
        removable: false,
      },
      items: {
        type: 'object',
        required: ['text'],
        properties: {
          text: {
            title: 'Text',
            type: 'string',
            'ui:options': {
              placeholder: DEFAULT_MARKDOWN_TEXT,
              type: 'textarea',
              rows: 6,
            },
          },
          textColor: {
            title: 'Text Color',
            type: 'string',
            default: DEFAULT_COLOR_GRAY,
          },
        },
      },
    },
  },
}
